import { PureComponent } from 'react';
import { FormError } from '@hc/component-lib/hclib/components/atoms/form-error';
import { TextArea as theme } from 'legacy/css-modules/generic';

class TextArea extends PureComponent {
  state = {
    value: this.props.input && this.props.input.value
  };

  handleChange = (e) => {
    if (this.props.onChange) {
      this.props.onChange(e);
    }
    if (this.props.input && this.props.input.onChange) {
      this.props.input.onChange(e);
    }
    this.setState({
      value: e.target.value
    });
  };

  render() {
    const {
      name,
      label,
      meta = {},
      maxLength,
      input,
      dataHcNames = {}
    } = this.props;
    const { error, touched } = meta;
    const { value } = this.state;
    return (
      <div className={theme.container}>
        {label && <label>{label}</label>}
        <textarea
          name={name}
          maxLength={maxLength}
          {...input}
          data-hc-name={dataHcNames.textarea}
          onChange={this.handleChange}
        />
        <div className={theme['input-meta']}>
          {error && touched && <FormError value={error} />}
          {maxLength && (
            <div
              className={theme['char-count']}
              data-hc-name={dataHcNames.charCount}
            >
              {`${value ? value.length : 0} / ${maxLength}`}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default TextArea;
